export enum UrlPathENUM {
  AUTH_SIGN_IN = '/auth/sign-in',
  AUTH_RESET_PASSWORD = '/auth/reset-password',
  CLIENT = '/client',
  CLIENT_SEARCH = '/client/search',
  USER_ME = '/user/me',
  ADDRESS = '/address',
  ADDRESS_FUZZY = '/address/fuzzy',
  ADDRESS_TEXT_OR_POSTCODE = '/address/search',
  ADDRESS_RESERVE = '/address/reserve',
  ADDRESS_RESERVE_FILE = '/address/reserve/file',
  ADDRESS_ACTIVE = '/address/active',
  ADDRESS_FILES = '/address/reserve/csv/files',
  ADDRESS_PURGE = '/address/reserve/csv/purge',
  FILE_STATUS = '/file-status',
}
